import { Action } from '../../../../../dispatcher/Types';

export const UpdateSidebarCustomAction: Action = [{
  args: ['customAction'],
  moduleName: 'Sidebar',
  name: 'updateCustomAction'
}];
